import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Dil dosyalarını direkt import edelim
import translationAZ from "../locales/az.json";
import translationEN from "../locales/en.json";

const langs = ["az", "en", "ru"];

// Dil kaynaklarını hazırlayalım
const resources = {
  az: {
    translation: translationAZ
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    whitelist: langs,
    fallbackLng: "az", // use az if detected lng is not available
    saveMissing: false, // Eksik çevirileri kaydetme özelliğini kapatalım
    debug: false, // Hata ayıklama modunu kapatalım
    interpolation: {
      escapeValue: false // react zaten XSS koruması sağlıyor
    }
  });

export default i18n;
